import dayjs from 'dayjs';
import cn from 'classnames';
import { UiText, UiTitle } from 'znanie-uikit';

import ImageProxy from 'components/common/ImageProxy';
import HtmlContent from 'components/common/HtmlContent';

import { useMediaQueries } from 'hooks/utils/useMediaQueries';

import { PostType } from 'graphql/types';

import css from './SinglePost.module.scss';

interface IProps {
  post: PostType;
}

export default function SinglePost({ post }: IProps) {
  const { isMobile } = useMediaQueries();

  return (
    <div className={css.block}>
      <div className={cn(css.cover, css.container)}>
        <ImageProxy
          src={
            isMobile && post.mobileImageUrl
              ? post.mobileImageUrl
              : post.imageUrl || ''
          }
          alt={`Обложка новости: ${post.title}`}
          layout="fill"
          objectFit="cover"
          objectPosition="center"
          sourceWidth={isMobile ? 450 : 840}
          sourceHeight={isMobile ? 240 : 480}
          resizingType="fill"
          gravityType="ce"
        />
      </div>
      <div className={css.container}>
        <div className={css.title}>
          <UiTitle as="h1" size="big" weight="normal">
            {post.title}
          </UiTitle>
        </div>
        <div className={css.date}>
          {dayjs(post.publishedAt).format('DD MMMM YYYY')}
        </div>
        <div className={css.description}>
          <UiText className={css.descriptionInner} as="p" weight="normal">
            {post.description}
          </UiText>
        </div>
        <HtmlContent html={post.body as string} />
      </div>
    </div>
  );
}
